import isNil from 'lodash-es/isNil'

import { EMPTY_LIST, EMPTY_STRING } from '../../../../constants/common'
import { getItemsIds, isEmptyString } from '../../../../utils/common'
import { isDwellerRole, isStaffUser } from '../../../../utils/user'
import { normalizeEmail } from '../../Email.utils'
import {
  getInputRecipientValue,
  toEmailRecipientFieldSelectItemsFromOption,
} from '../../EmailRecipientsField'

import { EMAIL_APPOINTMENT_SUBJECT_PREFIXES_REG_EXP } from './useEmailCreateAppointmentAction.constants'

function getEmailAppointmentSenderAnchor({ owner, sender }) {
  if (!isNil(owner?.id) && isStaffUser(owner)) {
    return {
      participants: toEmailRecipientFieldSelectItemsFromOption([owner]),
      resident: null,
    }
  }

  if (!isNil(owner?.id) && isDwellerRole(owner)) {
    const profile = { ...owner, email: sender?.email || owner.email }

    return {
      participants: toEmailRecipientFieldSelectItemsFromOption([profile]),
      resident: { id: owner.id, name: owner.fullname || profile.email },
    }
  }

  return {
    participants: sender?.email
      ? [getInputRecipientValue(sender.email)]
      : EMPTY_LIST,
    resident: null,
  }
}

function getIsEmailAppointmentOrganizerChip({ chip, organizer }) {
  const email = normalizeEmail(chip.email)

  return (
    (!isNil(chip.realId) && chip.realId === organizer?.id) ||
    (!isEmptyString(email) && email === normalizeEmail(organizer?.email))
  )
}

export function getEmailAppointmentTitle(subject) {
  return (subject ?? EMPTY_STRING)
    .replace(EMAIL_APPOINTMENT_SUBJECT_PREFIXES_REG_EXP, EMPTY_STRING)
    .trim()
}

// CAL-02 §7.3 rule 3: a colleague joins as internal, a resident or landlord also
// becomes the resident anchor, anyone else joins by the bare address
export function getEmailAppointmentSender({ message, organizer }) {
  const { participants, resident } = getEmailAppointmentSenderAnchor(message)

  return {
    participants: participants.filter(
      chip => !getIsEmailAppointmentOrganizerChip({ chip, organizer })
    ),
    resident,
  }
}

// An archived request takes no new appointment (BR-CAL-02-29)
export function getEmailAppointmentRequestProps(linkedRequests) {
  const requests = linkedRequests.filter(request => !request.archived)

  const [request, ...otherRequests] = requests

  return otherRequests.length > 0
    ? { requestIds: getItemsIds(requests) }
    : { request }
}

export function getEmailAppointmentLocation(request) {
  return request?.building?.address?.value
}

export function toEmailAppointmentThread(message) {
  return { id: message.email_thread_uuid, subject: message.subject }
}
